import Vue from 'vue';

export default Vue.component('ed-textarea-form', {
  name: 'ed-textarea-form',
  props: [
    'label', 
    'type',
    'disclamer',
    'placeholder',
    'readonly',
    'passwordIcon',
    'maxlength'
  ],
  inheritAttrs: false,
  data: () => {
    return {
      item: {},
      required: false
    }
  },
  computed: {
    textareaClass() {
      return {
        disabled: this.readonly
      }
    }
  },
  validations() {
    return {
      value: this.$attrs.value ? this.$attrs.value.validators : {}
    };
  },
  methods: {
    onBlur() {
      this.$emit('blur');
    },
    onTextarea() {
      this.$emit('input', this.item);
    }
  },
  created() {
    this.$attrs.value.validators = this.$attrs.value.validators ? this.$attrs.value.validators : {};
    this.required = this.$attrs.value.validators.required ? true : false;
    this.item = this.$attrs.value;
  },
  watch: {
    $attrs() {
      if(this.$attrs.value) {
        Vue.set(this, 'item', {
          valid: this.$attrs.value.valid,
          validators: this.$attrs.value.validators,
          value: this.$attrs.value.value,
        });
      }
    }
  }
});
